const dashboardEnglish = {
  greeting: {
    morning: "Good morning",
    afternoon: "Good afternoon",
    evening: "Good evening"
  },
  recentActivity: {
    title: "Recent Activity",
    empty: "No activity to show yet"
  },
  notifications: {
    title: "Notifications",
    loading: "Loading notifications...",
    newPost: "New LinkedIn post ready!",
    seeAll: "See all {count} posts",
    empty: "No notifications to show"
  }
};

export default dashboardEnglish; 